module.exports = __webpack_public_path__ + "static/img/14000594.5dddae36.png";